export interface MessageInitialState {
  showMessage: boolean;
  text: string;
  type: MessageType;
}

export enum MessageType {
  warning = "#f8b15d",
  danger = "#f95668",
  info = "#4285f4",
  success = "#09c97f",
}
